// Copyright (c) 2017 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const PipStatuses = t.struct({
    allowed: t.list(KeyValuePair, 'allowed'),
    selected: t.list(KeyValuePair, 'selected')
}, 'pipStatuses');

export const getDefaultState = () =>
    new PipStatuses({
        allowed: [],
        selected: []
    });

export default PipStatuses;



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/state/pip-statuses.js